module.exports = __webpack_public_path__ + "img/configuration_icon.b993147c.svg";